import { TextInput } from "./text-input";
import { Icons } from "components/icons";
import { InputBaseProps, WheelPicker } from "components";
import { FC, useMemo, useState } from "react";
import { COLOR_PALETTE } from "theme";
import { PickerData } from "react-simple-wheel-picker";

interface props extends InputBaseProps {
  value?: string;
  minuetStep?: 1 | 5 | 15;
  setValue?: (value: string) => void;
}

export const TimeInput: FC<props> = (props) => {
  const [open, setOpen] = useState(false);

  const minuetStep = useMemo(() => props.minuetStep || 1, [props.minuetStep]);

  const hourList: PickerData[] = useMemo(() => {
    return Array.from(Array(24)).map((_, i) => ({
      id: String(i).padStart(2, "0"),
      value: String(i).padStart(2, "0"),
    }));
  }, []);
  const minuetList: PickerData[] = useMemo(() => {
    const step = 60 / minuetStep;
    return Array.from(Array(step)).map((_, i) => ({
      id: String(i * minuetStep).padStart(2, "0"),
      value: String(i * minuetStep).padStart(2, "0"),
    }));
  }, [minuetStep]);

  const current = useMemo(() => {
    if (props.value) {
      const hour = props.value.substring(0, 2);
      const minuet = props.value.substring(3, 5);

      return {
        hour,
        minuet,
      };
    }
  }, [props.value]);

  const currentTime = useMemo(
    () => ({
      hour: new Date().getHours().toString().padStart(2, "0"),
      minuet: new Date().getMinutes().toString().padStart(2, "0"),
    }),
    []
  );

  const [selectedHourId, setSelectedHourId] = useState(
    current?.hour || currentTime?.hour
  );
  const [selectedMinuetId, setSelectedMinuetId] = useState(
    current?.minuet || currentTime?.minuet
  );

  const minuetId = useMemo(() => {
    if (!!minuetList.find((item) => item.id == selectedMinuetId)) {
      return selectedMinuetId;
    }
    return "00";
  }, [selectedMinuetId, minuetList]);

  return (
    <div>
      <TextInput
        {...props}
        inputProps={{
          readOnly: true,
          value: props.value,
          style: { unicodeBidi: "plaintext" },
          onClick: () => setOpen(true),
        }}
        endComponent={
          <div className="px-2">
            <Icons name="Clock" color={COLOR_PALETTE.primary} />
          </div>
        }
      />
      <dialog
        className="modal modal-top bg-[#333333CC]"
        open={open}
        onClose={() => setOpen(false)}
        onClick={() => setOpen(false)}
      >
        <div
          className="modal-box max-w-[320px] mx-auto p-3 bg-transparent shadow-none"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="bg-white rounded-2xl py-4">
            <div className="relative flex flex-col items-center mb-9">
              <div className="flex justify-center py-2 select-none divide-x divide-x-reverse divide-gray-300">
                <WheelPicker
                  items={minuetList}
                  selectedId={minuetId ?? ""}
                  onChange={setSelectedMinuetId}
                />
                <WheelPicker
                  items={hourList}
                  selectedId={selectedHourId ?? ""}
                  onChange={setSelectedHourId}
                />
              </div>
            </div>
            <div className="flex items-center justify-end px-4 gap-2">
              <button
                className="btn btn-ghost btn-sm text-gray-400"
                onClick={() => setOpen(false)}
              >
                انصراف
              </button>
              <button
                className="btn btn-ghost btn-sm text-gray-400"
                onClick={() => {
                  props.setValue!(`${selectedHourId}:${selectedMinuetId}`);
                  setOpen(false);
                }}
              >
                تایید
              </button>
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
};
